import { Button, Badge } from '@e2n/ui';
import { View } from '@/domain/mitarbeiter/features/rotationsplan/entities/views';
import { BerufeFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/BerufeFilter';
import { LehrjahrFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/LehrjahrFilter';
import { StandorteFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/StandorteFilter';
import { SortierungButton } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/SortierungButton.tsx';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import { faFilter } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

export function KalenderViewOptions() {
  const { t } = useTranslation();
  const { view } = useParams();
  const [filterOptionsVisible, setFilterOptionsVisible] = useState(false);
  const {
    store: {
      ui: {
        kalender: { filter },
      },
    },
  } = useRotationsplanFeatureContext();

  let selectedFilterCount = 0;
  Object.values(filter).forEach((filter) => {
    if (filter.length > 0) {
      selectedFilterCount += 1;
    }
  });

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <Button
          className="flex items-center gap-2"
          variant="ghost"
          onClick={() => setFilterOptionsVisible(!filterOptionsVisible)}>
          <FontAwesomeIcon icon={faFilter} />
          {t('domain.mitarbeiter.rotationsplan.filter.label')}
          <Badge type="pill" variant="secondary">
            {selectedFilterCount}
          </Badge>
        </Button>
        <SortierungButton view={view as View} />
      </div>
      {filterOptionsVisible && (
        <div className="flex items-center gap-2">
          <BerufeFilter view={view as View} />
          <LehrjahrFilter view={view as View} />
          <StandorteFilter view={view as View} />
        </div>
      )}
    </div>
  );
}
